"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var modal_container_1 = require('./modal-container');
var modal_backdrop_1 = require('./modal-backdrop');
var modal_window_1 = require('./modal-window');
var modal_stack_1 = require('./modal-stack');
var modal_1 = require('./modal');
var modal_2 = require('./modal');
exports.NgbModal = modal_2.NgbModal;
var modal_ref_1 = require('./modal-ref');
exports.NgbModalRef = modal_ref_1.NgbModalRef;
exports.NgbActiveModal = modal_ref_1.NgbActiveModal;
var modal_dismiss_reasons_1 = require('./modal-dismiss-reasons');
exports.ModalDismissReasons = modal_dismiss_reasons_1.ModalDismissReasons;
var NgbModalModule = (function () {
    function NgbModalModule() {
    }
    NgbModalModule.forRoot = function () { return { ngModule: NgbModalModule, providers: [modal_1.NgbModal, modal_stack_1.NgbModalStack] }; };
    NgbModalModule = __decorate([
        core_1.NgModule({
            declarations: [modal_container_1.NgbModalContainer, modal_backdrop_1.NgbModalBackdrop, modal_window_1.NgbModalWindow],
            entryComponents: [modal_backdrop_1.NgbModalBackdrop, modal_window_1.NgbModalWindow],
            providers: [modal_1.NgbModal],
            exports: [modal_container_1.NgbModalContainer]
        }), 
        __metadata('design:paramtypes', [])
    ], NgbModalModule);
    return NgbModalModule;
}());
exports.NgbModalModule = NgbModalModule;
//# sourceMappingURL=modal.module.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/modal/modal.module.js
// module id = 16
// module chunks = 0